import * as React from "react";
import {Header, Modal} from "semantic-ui-react";

import 'brace/mode/groovy'
import 'brace/ext/searchbox'
import {ScriptModifier} from "../ScriptModifier";

export interface ScriptModalProps {
    isOpen: boolean
    onClose: () => void
    script: string | null
    dispatcher: (script) => void
    saveKeyListener: (e: any) => void
    path: string
    readOnly: boolean
    fieldDescriptionEnabled: boolean
    defaultDescription: string | null
}

export function ScriptModal(props: ScriptModalProps) {
    console.log("[ScriptModal] - rendering with props script: " + props.script)
    return <Modal
        key="ScriptModal"
        id='ScriptModal'
        open={props.isOpen}
        onClose={props.onClose}
        dimmer="blurring"
        size='fullscreen'>
        <Header icon='browser' content='Edit Script'/>
        <Modal.Content
            style={{
                height: "calc(100vh - 100px)",
            }}
        >
            <ScriptModifier
                key="ScriptModifier"
                defaultDescription={props.defaultDescription}
                fieldDescriptionEnabled={props.fieldDescriptionEnabled}
                readOnly={props.readOnly}
                path={props.path}
                dispatcher={props.dispatcher}
                script={props.script}
                saveKeyListener={props.saveKeyListener}
            />
        </Modal.Content>
    </Modal>
}